// Voyantis motion eases — registered once, available globally as named eases.
// Requires: gsap, CustomEase (loaded via Webflow custom code).

// voyEase — the project's default scroll-reveal ease. Soft deceleration that
// "slows into rest" — used for new animations that don't have a Figma spec.
// CSS equivalent: cubic-bezier(0.22, 1, 0.36, 1)
export const VOY_EASE = 'voyEase';

// voyOutQuart — Figma's hero/acquire ease. Sharper deceleration, used in the
// existing entrance animations that were spec'd from Figma annotations.
// CSS equivalent: cubic-bezier(0, 0, 0, 1)
export const VOY_OUT_QUART = 'voyOutQuart';

// voyCustom — used for "scale-in" entrances and the acquire-section
// elastic-feeling transforms. Eases in slowly, decelerates hard.
// CSS equivalent: cubic-bezier(0.5, 0, 0, 1)
export const VOY_CUSTOM = 'voyCustom';

let registered = false;

/**
 * Register Voyantis custom eases with GSAP. Idempotent and safe to call
 * multiple times. Returns silently if CustomEase isn't loaded yet — the
 * caller should fall back to a built-in ease in that case.
 */
export function registerEasings() {
  if (registered) return true;
  if (typeof CustomEase === 'undefined') {
    console.warn('[motion] CustomEase plugin not loaded — falling back to power eases');
    return false;
  }

  if (!CustomEase.get(VOY_EASE)) {
    CustomEase.create(VOY_EASE, 'M0,0 C0.22,1 0.36,1 1,1');
  }
  if (!CustomEase.get(VOY_OUT_QUART)) {
    CustomEase.create(VOY_OUT_QUART, 'M0,0 C0,0 0,1 1,1');
  }
  if (!CustomEase.get(VOY_CUSTOM)) {
    CustomEase.create(VOY_CUSTOM, 'M0,0 C0.5,0 0,1 1,1');
  }

  registered = true;
  return true;
}

/**
 * Resolve an ease name with a safe fallback. If CustomEase isn't loaded,
 * returns a comparable built-in. Use this anywhere an ease string is needed.
 */
export function ease(name = VOY_EASE) {
  registerEasings();
  if (typeof CustomEase !== 'undefined' && CustomEase.get(name)) return name;
  // Fallback for environments without CustomEase
  if (name === VOY_OUT_QUART) return 'power4.out';
  if (name === VOY_CUSTOM) return 'power3.inOut';
  return 'power3.out';
}
